import { ChangeDetectorRef, Component, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { VersionTypesConfig } from '@app/apiModules/ReleaseConfigurationDto';
import { ConstantsService } from '@app/common/constants.service';
import { ReleaseConfigurationMappingDto } from '@app/shared/model/addOrUpdateReleaseConfigDto';
import { HotfixServicesConfigMappingDto } from '@app/shared/model/servicesConfigMappingDto';
import { AlertService } from '@app/shared/services/alert.service';
import { LoaderService } from '@app/shared/services/loader.service';
import { ReleaseMgmtService } from '@app/shared/services/releaseMgmtService';
import { ripple, textField, formField } from 'material-components-web';
import { ToastrService } from 'ngx-toastr';
import { UserAuthService } from '@app/shared/services/user-auth.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';
import { PageHeaderComponent } from '@app/shared/page-header/page-header.component';
import { ConfirmationDialogService } from '@app/shared/services/confirmation-dialog.service';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ReplaySubject, Subject, take, takeUntil } from 'rxjs';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    standalone: true,
    selector: 'app-create-or-update-hotfix',
    templateUrl: './create-or-update-hotfix.component.html',
    styleUrls: ['./create-or-update-hotfix.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatCheckboxModule, CommonModule, MatTooltipModule, TableModule, MultiSelectModule, SelectModule, PageHeaderComponent, MatSelectModule, MatIconModule, MatInputModule, MatFormFieldModule, NgxMatSelectSearchModule, RouterModule]
})
export class CreateOrUpdateHotfixComponent implements OnInit, OnDestroy, AfterViewInit {
  form: FormGroup;
  envServiceMap: { [env: string]: string } = {};
  configEnvironmentsInfoMsg = 'Show environments associated with a service';

  releaseServicesList: any[] = [];
  versionTypeList: any[] = [];
  environmentsList: any[] = [];
  preleaseId = 0;
  configSerInfoMsg = 'Select Applicable Services';
  configEnvInfoMsg = 'Select Applicable Environments';
  configReleaseNameInfoMsg =  'Allowed: Alphabets, Numbers, Full Stop and Hyphen. Maximum length: 50 characters. Expected Eg: Hotfix 4.4.1';
  configReleasePrefixInfoMsg = 'Allowed: Alphabets, Numbers, Full Stop and Hyphen. Maximum length: 50 characters. Expected Eg: h4.4';
  configVersionTypeInfoMsg = 'Select Version Type';
  parentReleaseNameInfoMsg = 'Define parent release from which the current hotfix or patch is derived.';
  configVersionNumberInfoMsg = 'Only Numbers and Full Stop is allowed';
  configExistingReleaseInfoMsg = 'Select Existing Release';
  configReleaseBranchNameInfoMsg = 'Select Branch Name';
  pageTitle = 'Define Hotfix and Map Services';
  pageSubTitle = 'Define Hotfix Configuration and Map Services';
  allselected = false;
  selectedVersionType = 'Hotfix';
  editableVersion: string;
  defaultVersionTypeList: { label: string; value: string }[] = [
    { label: 'Hotfix', value: 'Hotfix' },
    { label: 'Patch', value: 'Patch' },
  ];
  hotfixId: number;
  readonlyMode = false;
  isIndeterminate: boolean;
  allSelected: boolean;
  InfoForService: any;
  AllServiceList: any[];
  newReleaseServicesList: any[];
  public tooltipMessage = 'Select All / Unselect All';
  allElementsSelected = false;
  anyElementsSelected = false;
  /** control for the MatSelect filter keyword multi-selection */
  public environmentsFilterCtrl: FormControl<string> = new FormControl<string>('');
  /** list of environments filtered by search keyword */
  public filteredEnvironmentsMulti: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  /** Subject that emits when the component has been destroyed. */
  _onDestroy = new Subject<void>();
  enableAuditTrail = false;
  AllMappingList: any;
  hideField = false;
  constructor(public loader: LoaderService, public releaseMgmtService: ReleaseMgmtService,
    public router: Router, public route: ActivatedRoute, public toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    public userAuthService: UserAuthService,
    public alertService: AlertService,
    public constantService: ConstantsService,
    public confirmationDialog: ConfirmationDialogService
  ) { }


  ngOnInit() {
    this.preleaseId = Number(this.route.snapshot.paramMap.get('pReleaseId')) || 0;
    this.hotfixId = Number(this.route.snapshot.paramMap.get('hotfixId')) || 0;
    this.callApiTocheckBranchCreationStatus();
    this.form = new FormGroup({
      releaseName: new FormControl(null, [Validators.required]),
      releasePrefix: new FormControl(null, [Validators.required]),
      environments: new FormControl(null, [Validators.required]),
      selectedVersionType: new FormControl('Hotfix', [Validators.required]),
      parentReleaseName: new FormControl(null)
    });

    
    this.filteredEnvironmentsMulti.next([]);
    this.loader.showSpinner.next(true);
    this.releaseMgmtService.apiGetAllServicesAndEnvironmentDetails().subscribe({
      next: (res) => {
        if (res) {
          this.releaseServicesList = res.servicesConfig.map((service: any) => {
            const serviceDto = {
              code: service.code,
              isSelected: service.isSelected || false,
              serviceName: service.name,
              versionType: '',//{ key: res.versionTypesConfig.find(x => x.name == service.lastVersionType).code, value: service.lastVersionType },
              isAlreadyExist: service.IsAlreadyExist,
              versionNumber: '',//service.lastVersionNumber,
              previousNumber: '',//service.lastVersionNumber,
              lastVersionType: '',//service.lastVersionType,
              lastVersionNumber: '',//service.lastVersionNumber,
              serviceId: service.serviceId,
              isActive : service.isActive || false
            }
            return serviceDto;

          });
          this.AllMappingList = res.environmentsConfig;

          this.environmentsList = res.environmentsConfig.map((env: any) => {
            const envDto = {
              key: env.id,
              value: env.environmentName
            }
            return envDto;
          });
          // load the initial environment list
          this.filteredEnvironmentsMulti.next(this.environmentsList.slice());
          // listen for search field value changes
          this.environmentsFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
              this.filterEnvironments();
            });
          res.versionTypesConfig = res.versionTypesConfig.filter((versn: any) => {
            return versn.name !== 'Minor' && versn.name !== 'Major';
          });
          this.versionTypeList = res.versionTypesConfig.map((versn: any) => {
            const versionTypeDto = {
              key: versn.code,
              value: versn.name
            }
            return versionTypeDto;
          });
          this.loader.showSpinner.next(false);


          if (this.hotfixId && this.hotfixId !== 0) {
            this.getHotfixDetailsById();
          } else {
            this.setBranchNamebyReleaseId();
          }

        }
      }, error: (error) => {
        console.log(error);
        this.loader.showSpinner.next(false);

      }
    });

    this.hotfixId = Number(this.route.snapshot.paramMap.get('hotfixId')) || 0;
    if (this.hotfixId === 0) {
      this.readonlyMode = !this.userAuthService.checkPermission('MANAGE.RELEASE.ADD');
      this.enableAuditTrail = false;

    } else {
      this.readonlyMode = (!this.userAuthService.checkPermission('MANAGE.RELEASE.MODIFY')
        && this.userAuthService.checkPermission('MANAGE.RELEASE.STATUS.VIEW'));
      this.enableAuditTrail = true;

    }
    if (this.readonlyMode) {
      setTimeout(() => this.form.disable());
    }
  }
  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
  onMapServiceChange() {
    const environmentsValue = this.form.get('environments')?.value;
    const EnvString: string[] = Array.isArray(environmentsValue) ? environmentsValue.map((env: any) => env.value) : [];
    if (EnvString.length > 0) {

      this.releaseServicesList.forEach((service: any) => {
        const mappedEnvs: string[] = [];
        EnvString.forEach((envName: string) => {
          const mapping = this.AllMappingList.find((x: any) => x.environmentName === envName);
          if (mapping && Array.isArray(mapping.services)) {
            const found = mapping.services.find((svc: any) => svc.serviceName === service.serviceName);
            if (found && !mappedEnvs.includes(envName)) {
              mappedEnvs.push(envName);
            }
          }
        });
        service.mappedServiceNames = mappedEnvs.join(', ');
      });
    }

  }
  filterEnvironments() {
    if (!this.environmentsList) {
      return;
    }
    // get the search keyword
    let search = this.environmentsFilterCtrl.value;
    if (!search) {
      this.filteredEnvironmentsMulti.next(this.environmentsList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the environments
    this.filteredEnvironmentsMulti.next(
      this.environmentsList.filter(env => env.value.toLowerCase().indexOf(search) > -1)
    );
  }
  CheckAllCheckboxStatus() {
    this.filteredEnvironmentsMulti.subscribe(list => {
      const environments = this.form.get('environments')?.value.length > 0 ? this.form.get('environments')?.value : [];
      this.allElementsSelected = list.length > 0 && list.every(env => environments.some(e => e.value === env.value))
      this.CheckIntermittentStatus(list, environments)
    })
  }

  CheckIntermittentStatus(list, environments,) {
    this.anyElementsSelected = list.length > 0 && list.some(env => environments.some(e => e.value === env.value)) && !this.allElementsSelected;
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredEnvironmentsMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        if (selectAllValue) {
          this.form.get('environments')?.patchValue(this.environmentsList.map(env => env));
        } else {
          this.form.get('environments')?.patchValue([]);
        }
        this.allElementsSelected = selectAllValue;
        this.onEnvironmentChange();
      });
  }
  /* istanbul ignore next */
  onEnvironmentChange() {
    this.CheckAllCheckboxStatus();
    this.onMapServiceChange();
  }
  callApiTocheckBranchCreationStatus() {
    const id = this.hotfixId && this.hotfixId !== 0 ? this.hotfixId : this.preleaseId;
    if (id) {
      this.releaseMgmtService.apiCheckBranchCreationStatus(id).subscribe({
        next: (res) => {

          if (res == this.constantService.success) {

          } else {
            this.alertService.buildDialog().fire({
              title: 'Info',
              text: 'Please complete branch creation for existing hotfix/patch release',
              icon: this.alertService.WarningIcon,
              showCancelButton: false,
              confirmButtonText: 'OK',
              cancelButtonText: '',
            });
            this.router.navigate(['release']);
          }
        },
        error: (_error) => {

          this.alertService.buildDialog().fire({
            title: 'Error!',
            text: '',
            icon: this.alertService.WarningIcon,
            showCancelButton: false,
            confirmButtonText: 'OK',
            cancelButtonText: '',
          });
          this.router.navigate(['release']);
        }
      });
    }
  }
  getHotfixDetailsById() {
    if (this.hotfixId && this.hotfixId !== 0) {
      this.loader.showSpinner.next(true);
      // Fetch hotfix details by hotfixId
      this.releaseMgmtService.apiGetReleaseDataById(this.hotfixId).subscribe({
        next: (res) => {
          this.hideField = res.repoCreationStatus || false;
          this.loader.showSpinner.next(false);
          this.preleaseId = res?.servicesConfigMapping[0]?.parentReleaseId || 0;
          
          if (this.form && this.form.controls) {
          this.form.controls['releasePrefix']?.setValue(res.releasePrefix);
          this.form.controls['releaseName']?.setValue(res.releaseName);
          this.form.controls['parentReleaseName']?.setValue(res.parentReleaseName);
          this.form.controls['selectedVersionType']?.setValue(res.releaseType);

          this.form.controls['environments'].patchValue(res.environmentsConfigMapping.map((env: any) => {
            const selected = this.environmentsList.find(x => x.value === env.environmentName);
            return selected;
          }));
          }
          const versionType = res?.servicesConfigMapping[0]?.versionType;
          //Set Existing Branch+Upcoming Release
          this.setBranchNamebyHotfixReleaseId(res);
        }, error: (error) => {
          console.log(error);
          this.loader.showSpinner.next(false);

        }
      });
    }
  }
  checkAllSelected(releaseServicesList: any[]) {
    if (releaseServicesList.length > 0) {
      this.allselected = releaseServicesList.every((service: any) => service.isSelected);
    } else {
      this.allselected = false;
    }
  }
  captureOriginalVersion(row: any): void {
    if (row.existingVersion) {
      row.previousVersionNumber = row.existingVersion;
    }
  }

  onVersionValidate(value: string, row: any): void {
    if (row.existingVersion) {

      const inputSegments = (value || '').split('.');
      const lastSegments = (row.previousVersionNumber || '').split('.');

      if (inputSegments.length !== lastSegments.length) {
        this.toastr.error('Version format must be like: 3.2.1.0', 'Incorrect Format');
        row.versionNumber = row.previousVersionNumber;
        return;
      }

      const type = (row.versionType.value || '').toLowerCase();
      const typeToIndexMap: any = {
        major: 0,
        minor: 1,
        patch: 2,
        build: 3,
      };

      const allowedIndex = typeToIndexMap[type];
      let hasChangedOnlyAllowed = true;
      let isIncrement = true;

      for (let i = 0; i < inputSegments.length; i++) {
        const input = Number.parseInt(inputSegments[i], 10);
        const last = Number.parseInt(lastSegments[i], 10);

        if (Number.isNaN(input) || Number.isNaN(last)) {
          this.toastr.error('Version contains non-numeric parts.', 'Invalid Format');
          row.versionNumber = row.previousVersionNumber;
          return;
        }

        if (i === allowedIndex) {
          if (input <= last) {
            isIncrement = false; // Decrement or no change
          }
        } else {
          if (input !== last) {
            hasChangedOnlyAllowed = false;
          }
        }
      }

      if (!hasChangedOnlyAllowed) {
        this.toastr.error(`Only the ${type} version is allowed to be modified.`, 'Segment Issue');
        row.versionNumber = row.previousVersionNumber;
        return;
      }

      if (!isIncrement) {
        this.toastr.error(`The ${type} version must be in Incremental order.`, 'Version Decrement');
        row.versionNumber = row.previousVersionNumber;
        return;
      }

      row.versionNumber = value;
    }
  }
  /* istanbul ignore next */
  initMatComponent() {
    [].map.call(document.querySelectorAll('.text-material'), function (element) {
      textField.MDCTextField.attachTo(element);
    });

    [].map.call(document.querySelectorAll('.ripple-material'), function (el) {
      ripple.MDCRipple.attachTo(el);
    });
  }

  /* istanbul ignore next */
  ngAfterViewInit() {
    this.hotfixId = Number(this.route.snapshot.paramMap.get('hotfixId')) || 0;
    if (this.IsNullOrEmpty(this.hotfixId) || this.hotfixId === 0) {
      this.initMatComponent();
    }
    setTimeout(() => {
      [].map.call(document.querySelectorAll('.text-material'), function (element) { textField.MDCTextField.attachTo(element); });
      [].map.call(document.querySelectorAll('.ripple-material'), function (el) { ripple.MDCRipple.attachTo(el); });
      [].map.call(document.querySelectorAll('.formfield-material'), function (elem) { formField.MDCFormField.attachTo(elem); });
    }, 2000);

    
  }

  onVersionChange(row) {
    if (row.versionType) {
      // Show the spinner by setting the value of "showSpinner" property in "loader" object to true
      
      // Call the "apiGetVersionNumberByVersionType" method of "releaseMgmtService" object, passing the "versionType" value and "serviceName" from "row" as arguments
      // Subscribe to the response of the API call
      this.releaseMgmtService.apiGetVersionNumberByVersionType(this.preleaseId, row.versionType.value, row.serviceName).subscribe({
        next: (res) => {
          // If the response is not null or undefined
          if (res) { row.versionNumber = res;  }
        }, error: (error) => {
          // If there is an error in the API call, log the error to the console
          console.log(error);
          // Hide the spinner by setting the value of "showSpinner" property in "loader" object to false
          
        }
      })
    }
  }

  checkIfNotSelected(row): boolean {
    return !row.isSelected || row.isAlreadyExist;
  }

  setBranchNamebyReleaseId(): any {
    if (this.preleaseId && this.preleaseId !== 0) {
      this.loader.showSpinner.next(true);


      this.releaseMgmtService.fetchExistingServiceRecordbyReleaseId(this.preleaseId).subscribe({
        next: (res) => {
          if (res) {
            this.releaseServicesList = this.releaseServicesList
              .filter((service: any) => res.some(x => x.serviceName === service.serviceName))
              .map((service: any) => {
                const serviceDto = res.find(x => x.serviceName === service.serviceName);
                const branchName = serviceDto?.branchName || '';

                return {
                  ...service,
                  branchName: branchName,
                  releaseName: serviceDto?.releaseName
                };

              });
              this.loader.showSpinner.next(false);

            // this.form.controls["releaseName"].setValue('Hotfix 4.4.1');
            // this.form.controls["releasePrefix"].setValue('h4.4');
            this.initMatComponent();
            this.setVersionNumberByReleaseId();

            this.releaseServicesList = this.releaseServicesList.filter(svc => svc.isSelected === true || svc.isActive === true);  
            this.loader.showSpinner.next(false);
          }
        }, error: (error) => {
          this.loader.showSpinner.next(false);

        }
      })

    }
  }
  setBranchNamebyHotfixReleaseId(hotfixResponse: any): any {
    if (this.preleaseId && this.preleaseId !== 0) {
      
this.loader.showSpinner.next(true);
      this.releaseMgmtService.fetchExistingServiceRecordbyReleaseId(this.preleaseId).subscribe({
        next: (parentReleaseRes) => {
          if (parentReleaseRes && hotfixResponse?.servicesConfigMapping) {
            const hotfixServices = hotfixResponse.servicesConfigMapping;
            this.releaseServicesList = this.releaseServicesList.map((service: any) => {
              let versionTypeDto;

              const hotfixDto: HotfixServicesConfigMappingDto = hotfixServices.find(x => x.serviceId === service.serviceId);
              if (hotfixDto) {
                versionTypeDto = hotfixDto?.versionType === 'Patch' ? { key: '4', value: 'Patch' } : { key: '3', value: 'Hotfix' };
                return {
                  ...service,
                  branchName: hotfixDto.sourceBranch,
                  releaseName: hotfixDto.releaseName,
                  versionNumber: hotfixDto.versionNumber,
                  versionType: versionTypeDto,
                  isAlreadyExist: true,
                  isSelected: true,
                  isActive : hotfixDto.isActive || false
                };

              } else {
                //Check for parent release data
                const parentServiceDto: HotfixServicesConfigMappingDto = parentReleaseRes.find(x => x.serviceName === service.serviceName);
                if (parentServiceDto) {
                  const branchName = parentServiceDto?.branchName || '';

                  return {
                    ...service,
                    branchName: branchName,
                    releaseName: parentServiceDto?.releaseName,
                    isAlreadyExist: false,
                    isSelected: false
                  };
                }
                return null;
              }
            })
              .filter(service => service !== null);

            this.releaseServicesList = this.releaseServicesList.filter(svc => svc.isSelected === true || svc.isActive === true);  
            this.onRowCheckboxChange();
            this.initMatComponent();
            this.setVersionNumberByReleaseId();
          }
this.loader.showSpinner.next(false);
          
        },
        error: (error) => {
          this.loader.showSpinner.next(false);
        },
        complete: () => {
          this.onMapServiceChange();
        }
      });
    }

  }

  setVersionNumberByReleaseId() {
    this.selectedVersionType = this.form.get('selectedVersionType').value;

    if (this.selectedVersionType) {
      // 
      this.releaseMgmtService.apiGetDefaultVersionNumberByVersionType(this.preleaseId, this.selectedVersionType).subscribe({
        next: (res) => {
          if (res) {
            this.releaseServicesList.forEach((row: any) => {
              if (row.isAlreadyExist) {
                return;
              }

              const matchedVersion = res[row.serviceName];
              if (matchedVersion) {
                row.versionNumber = matchedVersion;
                row.existingVersion = matchedVersion; // Store the existing version for validation
                row.versionType = {
                  key: this.versionTypeList.find(x => x.value === this.selectedVersionType).key,
                  value: this.selectedVersionType
                };
              }
            });

            
            this.checkAllSelected(this.releaseServicesList);
            this.cdr.detectChanges();
          }
        },
        error: (error) => {
          console.error('Failed to fetch default version number:', error);
          
        }
      });
      // 

    }

  }

  isInvalidForm() {
    if (this.form.invalid || !this.releaseServicesList.some(x => x.isSelected === true) ||
      this.releaseServicesList.some(x => x.isSelected === true && (this.IsNullOrEmpty(x.versionNumber) || this.IsNullOrEmpty(x.versionType)))) {
      return true;
    }
    return false;
  }

  // omit special characters
  /* istanbul ignore next */
  omit_special_char(event, isAlphaNumeric: boolean, addtionalCharAllowed: number[] = []) {
    // get char code
    const key = typeof event?.key === 'string' ? event.key : '';
    const k = key.codePointAt(0) ?? event?.charCode ?? event?.which ?? event?.keyCode;
    if (k === undefined) {
      return false;
    }

    if (isAlphaNumeric) {
      // allowed only Alphabets, numbers, full stop & hyphen
      return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || addtionalCharAllowed.includes(k) || k == 45 || k == 46 || (k >= 48 && k <= 57));
    }
    else {
      // allowed only number & full stop
      return (k == 46 || (k >= 48 && k <= 57));
    }
  }

  // omit special characters on paste
  /* istanbul ignore next */
  on_paste_omit_special_char(event: ClipboardEvent, control, addtionalCharAllowed: number[] = []) {
    // local variables
    const clipboardData = event.clipboardData;
    let filteredText = '';

    // get text
    const pastedText = clipboardData.getData('text');
    let k;

    // loop to check for every char
    for (let i = 0; i < pastedText.length; i++) {
      k = pastedText.codePointAt(i) ?? 0;
      if ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || addtionalCharAllowed.includes(k) || k == 45 || k == 46 || (k >= 48 && k <= 57)) {
        filteredText += pastedText.charAt(i)
      }
    }
    this.form.controls[control].setValue(filteredText);

    // return false
    return false;
  }
  save() {
    this.fetchEnvironmentForPopup();
  }
  /* istanbul ignore next */
  fetchEnvironmentForPopup() {

    this.AllServiceList = this.releaseServicesList;
    const EnvString: string[] = this.form.get('environments').value.map((env: any) => env.value);
    if (EnvString.length === 0) {
      
      return;
    }
    this.releaseMgmtService.apiGetServiceListByEnv(EnvString).subscribe({
      next: (res) => {
        if (res) {
          this.InfoForService = res.services;
          // Clear the existing list
          this.releaseServicesList = [];
          // Iterate over each environment in res.environments
          Object.entries(res.environments).forEach(([envName, serviceNames]: [string, string[]]) => {
            // For each service name in the environment
            serviceNames.forEach((serviceName: string) => {
              // Find the matching service config from res.servicesConfig
              const serviceConfig = this.AllServiceList.find((svc: any) => svc.serviceName === serviceName);
              if (serviceConfig) {
                // Check if this service/environment combination already exists in the list
                const alreadyExists = this.releaseServicesList.some(
                  (svc: any) => svc.serviceName === serviceName
                    && svc.isSelected === true
                );
                // If alreadyExists, add envName to selectedEnvironment as an array
                if (alreadyExists) {
                  const existingService = this.releaseServicesList.find(
                    (svc: any) => svc.serviceName === serviceName
                  );
                  if (existingService) {
                    if (!Array.isArray(existingService.selectedEnvironment)) {
                      existingService.selectedEnvironment = [existingService.selectedEnvironment];
                    }
                    if (!existingService.selectedEnvironment.includes(envName)) {
                      existingService.selectedEnvironment.push(envName);
                    }
                  }
                }
                else {
                  this.releaseServicesList.push({
                    isActive : serviceConfig.isActive || false,
                    serviceName: serviceName,
                    isSelected: serviceConfig.isSelected,
                    versionType: serviceConfig.versionType,
                    versionNumber: serviceConfig.versionNumber,
                    branchName: serviceConfig.branchName,
                    selectedEnvironment: envName, // Set the environment name
                    isAlreadyExist: serviceConfig.isAlreadyExist,
                    serviceId: serviceConfig.serviceId
                  });
                }

              }
            });
          });
        }
      },
      error: (error) => {
        this.toastr.error('Failed to load environments');
      },
      complete: () => {
        
        this.openDeploymentDialog();

      }
    });

  }
  /* istanbul ignore next */
  async openDeploymentDialog() {
    this.envServiceMap = {};
    this.releaseServicesList
      .filter(service => service.isSelected)
      .forEach(service => {
        if (service.selectedEnvironment && Array.isArray(service.selectedEnvironment)) {
          service.selectedEnvironment.forEach((env: string) => {
            if (!this.envServiceMap[env]) {
              this.envServiceMap[env] = service.serviceName;
            } else {
              this.envServiceMap[env] += ', ' + service.serviceName;
            }
          });
        } else if (service.selectedEnvironment) {
          // Handle single environment string
          const env = service.selectedEnvironment;
          if (!this.envServiceMap[env]) {
            this.envServiceMap[env] = service.serviceName;
          } else {
            this.envServiceMap[env] += ', ' + service.serviceName;
          }
        }
      });
    const confirmed = await this.confirmationDialog.showReleaseConfirmation(this.envServiceMap, 'hotfix', this.InfoForService);

    if (confirmed) {
      this.proceedForSave();
    }
  }
  proceedForSave() {
    const releaseName = this.form.get('releaseName').value;
    const releasePrefix = this.form.get('releasePrefix').value;

    if (this.isInvalidForm() || (releaseName && releaseName.trim() == '') || (releasePrefix && releasePrefix.trim() == '')) {
      this.toastr.error('Version contains non-numeric parts', 'Invalid Format');
      return;
    }
    const serviceMappingDetails: ReleaseConfigurationMappingDto = {
      Id: this.hotfixId,
      ReleaseName: this.form.get('releaseName').value,
      ReleasePrefix: this.form.get('releasePrefix').value,

      ServicesConfigMapping: this.releaseServicesList.filter(x => x.isSelected === true).map((service: any) => {
        return {
          Id: 0,
          ReleaseId: this.hotfixId,
          ServiceName: service.serviceName || '',
          VersionType: service.versionType.value,
          VersionNumber: service.versionNumber || 0,
          BranchName: this.form.get('releasePrefix').value || '',
          ParentReleaseId: this.preleaseId,
          SourceBranch: service.branchName || '',
          serviceId: service.serviceId,
          isActive : service.isActive || false
        };
      }),

      EnvironmentsConfigMapping: this.form.get('environments').value.map((env: any) => { return { EnvironmentId: env.key, EnvironmentName: env.value, ReleaseId: this.hotfixId } })

    };
    
    this.releaseMgmtService.apiSaveReleaseDetails(serviceMappingDetails).subscribe({
      next: (res) => {
        if (res) { this.toastr.success('The Release definition is saved successfully', 'Success');  this.router.navigate(['release']); }
      }, error: (error) => { console.log(error);  }
    })
  }

  cancel() {
    this.router.navigate(['release']);
  }

  IsNullOrEmpty(value: any): boolean {
    if (value === null || value === undefined || value === '') {
      return true;
    }
    return false;
  }

  toggleAllRows() {
    this.releaseServicesList.forEach(service => {
      if (!service.isAlreadyExist) {
        service.isSelected = this.allSelected;
      }
    });
    //this.isIndeterminate = false;
    this.onRowCheckboxChange();
  }

  onRowCheckboxChange() {
    const total = this.releaseServicesList.length;
    const selected = this.releaseServicesList.filter(service => service.isSelected).length;
    this.allSelected = selected === total;
    this.isIndeterminate = selected > 0 && selected < total;

  }
  isEnvironmentMissing(): boolean {
    const environment = this.form.get('environments')?.value || [];
    if (environment.length > 0) {
      return false;
    } else {
      return true;
    }
  }
  onCheckboxToggle(row: any, event: any): void {
    //   const environment = this.form.get('environments')?.value || [];
    //   if (event.checked && row.serviceName) {
    //   }
  }

  navigateToAuditTrail() {
    this.router.navigate(
      ['/release/define-hotfix/audit-trails', this.hotfixId],
      { queryParams: { backTo: 'hotfix' } }
    );
  }

}
